import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../appStore";
import { EAppReducers } from "../../white-list";

const getState = (state: RootState) => state[EAppReducers.USER];

export const userSelector = createSelector(getState, (state) => state);
